import axios from "axios";
import { toast } from "react-toastify";
import baseURL from "../Config";

export const loginService =
    (data, url, isShowLoad = false, isShowToast = true) =>
    async (dispatch) => {
        try {
            const loginData = JSON.parse(localStorage.getItem("rememberMe") === "y" ? localStorage.getItem("userDetails") : sessionStorage.getItem("userDetails"));
            const accessToken = loginData?.data?.accessToken;
            const response = await axios({
                method: "post",
                url: `${baseURL + url}`,
                data: data,
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${accessToken}`,
                },
            });
            if (isShowToast) toast.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 500) {
                toast.warn(error?.response?.data?.message || "Something went wrong !!");
            } else {
                toast.warn(error?.response?.data?.message || "Something went wrong !!");
            }
            return error?.response;
        }
    };
